import includes from 'lodash/includes';
import ReducerBuilder from 'classes/ReducerBuilder';
import editFiltersReducerInitialState from './initialState';

const reducer = ReducerBuilder.make(editFiltersReducerInitialState)
    .forType("RECEIVED_ALL_RESOURCES_FILTER")
    .reduce((state, action) => {
        for (let filter of action.resources) {
            if (filter.resource === "challenge" && !includes(state.challengeFilters, filter.name)) {
                state.challengeFilters = state.challengeFilters.concat(filter.name);
            }
            else if (filter.resource === "image" && !includes(state.imageFilters, filter.name)) {
                state.imageFilters = state.imageFilters.concat(filter.name);
            }
            else if (filter.resource === "prize" && !includes(state.prizeFilters, filter.name)) {
                state.prizeFilters = state.prizeFilters.concat(filter.name);
            }
        }
    })
    .build();

export default reducer;



// WEBPACK FOOTER //
// ./public/filters/filters-reducer.js